import moment from 'moment';
import { Calendar } from 'primereact/calendar';
import React, { useState, useEffect } from 'react';
import useEffectOnce from 'src/hooks/useEffectOnce';
import { OPCIONES_VIGENCIA } from 'src/reducers/Cotizacion/cotizacion.reducer';
import { setCotizacionConfig } from 'src/reducers/Cotizacion/cotizacion.actions';
import { POST } from 'src/services';
import { urlEditVigencia } from 'src/services/urls';
import { useDispatch } from 'react-redux';
import useCustomToast from 'src/hooks/useCustomToast';

// const today = moment().format('DD/MM/yyyy');

const EditarVigencia = ({ cotizacion }) => {
  const dispatch = useDispatch()
  const d = new Date(cotizacion.finVigencia);
  const m = moment(d).toISOString;

  const { addWarningToast } = useCustomToast()
  const [value, setValue] = useState<any>(cotizacion.inicioVigencia);
  const [valueFin, setValueFin] = useState<any>(cotizacion.finVigencia);

  const [maxDate, setmaxDate] = useState(null);
  const [minDate, setminDate] = useState(null);


  useEffectOnce(() => {
    if (cotizacion.capturaVigencia === OPCIONES_VIGENCIA.AUTOMATICO) {
      setVigencia();
    }
  });

  // verifica cambios e los estados de las fechas para eviar a guardar
  useEffect(() => {
    setVigencia();
  }, [value, valueFin])

  // Evia a guardar la vigecia del producto
  const setVigencia = () => {
    console.log('setVigencia', value, valueFin)
    POST(urlEditVigencia, {
      idCotizacion: cotizacion.idCotizacion,
      fecha: value,
      fechaFin: valueFin
    }).then(({ fechaVigencia }) => {
      // dispatch(setCotizacionConfig({ ...cotizacion, finVigencia: fechaVigencia }))
    });
  };

  useEffect(() => {
    if (cotizacion.empAplica === "hyundai") {
      setmaxDate(moment(new Date()).add(30, 'days').toDate())
      setminDate(moment(new Date()).add(-30, 'days').toDate())
    }
  }, [])

  // fucion para formatear ua fecha
  // const formatDate = (date) => moment(date).format('DD/MM/yyyy');

  //si las opcioes o es MANUAL o INICIO_FIN, o rederiza nada
  if (!(cotizacion.capturaVigencia === OPCIONES_VIGENCIA.MANUAL || cotizacion.capturaVigencia === OPCIONES_VIGENCIA.INICIO_FIN))
    return null

  // crea string para rango del compoete calendar
  const rango = `${moment(new Date()).year() - 20}:${moment(new Date()).year() + 20}`

  console.log("Fecha value", value)

  return <>
    <div className="row justify-content-center">
      <div className="col-10 col-md-5 col-lg-4 col-xl-3 mt-3">
        <span className="p-float-label">
          <Calendar
            className="w-100"
            showIcon
            value={value}
            showButtonBar
            showSeconds
            dateFormat='dd/mm/yy'
            minDate={minDate}
            maxDate={maxDate}
            yearRange="2000:2050"
            yearNavigator
            monthNavigator
            onChange={(evt) => {
              if (evt.value) {
                setValue(evt.value);
              }
            }}
            onMonthChange={() => {}}
          />
          <label htmlFor="">Seleccione la fecha de inicio de la vigencia</label>
        </span>
      </div>

      {/* se muestra solo si se puede editar la vigencia de fin */}
      {cotizacion.capturaVigencia === OPCIONES_VIGENCIA.INICIO_FIN &&
        <div className="col-10 col-md-5 col-lg-4 col-xl-3 mt-3">
          <span className="p-float-label">
            <Calendar
              className="w-100"
              showIcon
              value={valueFin}
              showButtonBar
              showSeconds
              yearRange={rango}
              yearNavigator
              monthNavigator
              onChange={(evt) => {
                if (evt.value) {
                  setValueFin(evt.value);
                }
              }}
              onMonthChange={() => {}}
            />
            <label htmlFor="">Seleccione la fecha de Fin de la vigencia</label>
          </span>
        </div>}
    </div>
  </>;
};

export default EditarVigencia;
